import { useStore } from "@utilities/UseStore";
import { Dojo, Gender, Interest, LeadType, Outcome, AgeGroup, InterestTimeline } from "./LeadOptions";
import { isArray } from "lodash";

export const useLead = () => useStore( 'gkr-lead', class 
{

    date: Date = new Date();
    salespersonId: string = null as any;
    region: string = null as any;
    leadType?: LeadType;
    ageGroup?: AgeGroup | AgeGroup[];
    gender?: Gender | Gender[];
    interest?: Interest;
    interestTimeline?: InterestTimeline;
    dojo?: Dojo;
    outcome?: Outcome;
    introduction?: string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    email?: string;

    
    /**
     * Starts a new lead
     */
    startNew( salespersonId: string, region: string )
    {
        Object.keys( this ).forEach( k => ( this as Record<string,any>)[ k ] = undefined );
        this.date = new Date();
        this.salespersonId = salespersonId;
        this.region = region;
    }

    /**
     * Saves the lead
     */
    async save( sendInformationEmail?: boolean )
    {

    }

    get hasFemale()
    {
        return this.gender === Gender.female || ( isArray( this.gender ) && this.gender.some( v => v == Gender.female ) );
    }

    get hasMale()
    {
        return this.gender === Gender.male || ( isArray( this.gender ) && this.gender.some( v => v == Gender.male ) );
    }

    get hasMaleAndFemale()
    {
        return this.hasFemale && this.hasMale;
    }

    get hasChild()
    {
        return this.ageGroup !== AgeGroup.band4 || ( isArray( this.ageGroup ) && this.ageGroup.some( v => [ AgeGroup.band1, AgeGroup.band2, AgeGroup.band3 ].includes( v ) ) );
    }

    get hasTeenager()
    {
        return this.ageGroup === AgeGroup.band3 || ( isArray( this.ageGroup ) && this.ageGroup.some( v => [ AgeGroup.band3 ].includes( v ) ) );
    }

});